var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFiBrCrossSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 11.9998L18.0001 8.11677C18.2519 7.83053 18.3853 7.45913 18.3732 7.07807C18.361 6.697 18.2042 6.33487 17.9346 6.06527C17.665 5.79568 17.3029 5.63886 16.9218 5.6267C16.5407 5.61453 16.1693 5.74793 15.8831 5.99977L12.0001 9.87877L8.11008 5.98777C7.97074 5.84844 7.80533 5.73792 7.62329 5.66251C7.44124 5.58711 7.24612 5.54829 7.04908 5.54829C6.85203 5.54829 6.65691 5.58711 6.47487 5.66251C6.29282 5.73792 6.12741 5.84844 5.98808 5.98777C5.84874 6.12711 5.73822 6.29252 5.66281 6.47457C5.58741 6.65661 5.5486 6.85173 5.5486 7.04877C5.5486 7.24582 5.58741 7.44094 5.66281 7.62298C5.73822 7.80503 5.84874 7.97044 5.98808 8.10977L9.87908 11.9998L6.00008 15.8818C5.84795 16.0178 5.72517 16.1834 5.63924 16.3684C5.55331 16.5535 5.50605 16.7542 5.50034 16.9581C5.49463 17.1621 5.5306 17.3651 5.60604 17.5547C5.68148 17.7443 5.79481 17.9165 5.9391 18.0608C6.08338 18.205 6.25558 18.3184 6.44517 18.3938C6.63476 18.4693 6.83775 18.5052 7.04172 18.4995C7.24569 18.4938 7.44635 18.4465 7.63142 18.3606C7.81649 18.2747 7.98209 18.1519 8.11808 17.9998L12.0001 14.1208L15.8781 17.9998C16.1595 18.2812 16.5411 18.4393 16.9391 18.4393C17.337 18.4393 17.7187 18.2812 18.0001 17.9998C18.2815 17.7184 18.4396 17.3367 18.4396 16.9388C18.4396 16.5408 18.2815 16.1592 18.0001 15.8778L14.1211 11.9998Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiBrCrossSmall);
export default __webpack_public_path__ + "static/media/fi-br-cross-small.fad24278951c4249c90bd6526e3f18f7.svg";
export { ForwardRef as ReactComponent };